import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatDatetimepickerModule} from '@mat-datetimepicker/core';
import {MxDynamicFieldsModule, MxMaterialModule} from 'mx-core';
import {SharedModule} from '../../shared/shared.module';
import {BoFilterComponent} from './components/filter/bo-filter.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        MxMaterialModule,
        MxDynamicFieldsModule,
        MatDatetimepickerModule
    ],
    declarations: [
        BoFilterComponent
    ],
    exports: [
        BoFilterComponent
    ],
})
export class BoFilterModule {
}
